import { IPermission } from '@interfaces/fc-user/permissions';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const practitionerPermissionSlice = createSlice({
    name: 'practitioner-permission',
    initialState: {
        permission: [],
    } as {permission: IPermission[]},
    reducers: {
        setPermissions: (state, action: PayloadAction<IPermission[]>) => {
            state.permission = action.payload;
        },
        cleanPermissions: (state) =>{
            state.permission  = []
        }
    },
});

export const { setPermissions,cleanPermissions } = practitionerPermissionSlice.actions;
export default practitionerPermissionSlice.reducer;
